var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "26", height: "14", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M6 0h12a6 6 0 1 1 0 12H6A6 6 0 1 1 6 0z", id: "a" }),
      React.createElement("circle", { id: "b", cx: "18", cy: "6", r: "3.333" })
    ),
    React.createElement(
      "g",
      { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
      React.createElement("use", { stroke: "#FFF", fill: "#11A0D2", fillRule: "nonzero", xlinkHref: "#a" }),
      React.createElement("path", { d: "M6.5 4.5v3", stroke: "#FFF", strokeLinecap: "square" }),
      React.createElement("use", { fill: "#FFF", transform: "matrix(-1 0 0 1 36 0)", xlinkHref: "#b" })
    )
  );
});